import store from '@/store';
import { isDev } from '@utils/flag';
import { Toast } from 'vant';
import bridge from './bridge';
import Axios from 'axios'
import JsonBigint from 'json-bigint'



const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};

const $ = window.Zepto;
const tenantId = '';

const BASE_URL = isDev()
  ? process.env.VUE_APP_ROUTER
  : `${window.location.origin}/api`;

function check(obj) {
  const localAccount = JSON.parse(localStorage.getItem('account')) || {}

  delete obj['name'];
  delete obj['plazaName'];

  for (let i in obj) {
    obj[i] = localAccount[i] || obj[i];
    

    if (!obj[i]) {
      delete obj[i];
    }

    if (obj[i] && /[\u4e00-\u9fa5]+/.test(obj[i])) {
      obj[i] = encodeURIComponent(obj[i]);
    }
  }
  return obj;
}

function axios(methods, url, data, headers, config) {
  headers = check(
    Object.assign({ tenantId }, Object.assign(headers, store.state.account))
  );

  // return new Promise((rs, rj) => {
  //   $.ajax({
  //     type: methods,
  //     url: BASE_URL + url,
  //     headers,
  //     data,
  //     success(res) {
  //       rs(res);
  //     },
  //     error(err) {
  //       Toast({
  //         message:'网络请求失败',
  //         duration:4000
  //       })
  //       rj(err);
  //     },
  //     ...config,
  //   });
  // });
  if (methods == 'POST') {
    return new Promise((rs, rj) => {
      Axios({
        method: methods,
        url: BASE_URL + url,
        data,
        headers,
        transformResponse: [
          function (data) {
            // 对 data 进行任意转换处理
            try {
              return JsonBigint.parse(data)
            } catch (err) {
              return data
            }
          }

        ]

      }).then(res => {
        rs(res.data)
      }).catch(err => {
        rj(err)
      })
    })
  } else {
    return new Promise((rs, rj) => {
      Axios({
        method: methods,
        url: BASE_URL + url,
        params: data,
        headers,
        transformResponse: [
          function (data) {
            // 对 data 进行任意转换处理
            try {
              return JsonBigint.parse(data)
            } catch (err) {
              return data
            }
          }

        ]
      }).then(res => {
        rs(res.data)
      }).catch(err => {
        rj(err)
      })
    })
  }

}

module.exports = {
  get(url, data, headers = {}, config) {
    return axios('GET', url, data, headers, config);
  },
  post(url, data, headers = {}, config) {
    return axios('POST', url, data, headers, config);
  },
  put(url, data, headers = {}, config) {
    return axios('PUT', url, data, headers, config);
  },

};
